export default __webpack_public_path__ + "static/894-0229ee5a195d47d2090d0a0fb1860e71.gif";